<app-parent-empty-state
  [centered]="true"
  [titleKey]="titleKey()"
  [subtitleKey]="subtitleKey()"
  [ariaLabelKey]="ariaLabelKey()"
  [iconMask]="iconMask()"
>
  @if (showAddKidCta()) {
    <app-parent-button parentEmptyActions variant="ghost" (clicked)="openAddKidDialog()">
      <span class="home-empty-state__btn-icon home-empty-state__btn-icon--kid" aria-hidden="true"></span>
      {{ 'app.components.homeEmptyState.assignments.addKid' | translate }}
    </app-parent-button>
  } @else if (showAddDutyCta()) {
    <app-parent-button parentEmptyActions variant="ghost" (clicked)="onAddNewAssignment()">
      <span class="home-empty-state__btn-icon home-empty-state__btn-icon--plus" aria-hidden="true"></span>
      {{ 'app.components.homeEmptyState.assignments.addDuty' | translate }}
    </app-parent-button>
  }
</app-parent-empty-state>
